import { Heading } from '@apollo/orbit';
import React from 'react';

interface Props {
  className?: string;
  title?: string;
  actions?: React.ReactNode;
  list: Array<{
    key: string;
    name: React.ReactNode;
    value: React.ReactNode;
    hide?: boolean;
  }>;
}

export function DefinitionList({ className, title, actions, list }: Props) {
  return (
    <div className={className}>
      <Heading className="flex justify-between" as="h2" variant="subtitle">
        {title}
        {actions && <div>{actions}</div>}
      </Heading>
      <dl className="mt-2 grid grid-cols-6">
        {list
          .filter(({ hide }) => !hide)
          .map(({ key, name, value }) => (
            <React.Fragment key={key}>
              <dt className="col-span-2 border-b border-primary py-2 pr-2 text-xs font-semibold uppercase text-secondary">
                {name}
              </dt>
              <dd className="col-span-4 flex flex-wrap gap-2 border-b border-primary py-2">
                {value}
              </dd>
            </React.Fragment>
          ))}
      </dl>
    </div>
  );
}
